import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface WithdrawalFundType {
  token: string | null;
  currency: string;
  amount?: number;
  totalFee?: number;
}

export const getWithdrawalFund = async ({
  token,
  currency,
  amount,
}: WithdrawalFundType) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/payment/ledger/withdrawal-fund?currency=${currency}&amount=${amount}`, // Pass amount as query parameter
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export const confirmWithdrawalFund = async ({
  token,
  currency,
  amount,
  totalFee,
}: WithdrawalFundType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/payment/ledger/confirm-withdrawal-fund`,
      { currency, amount, totalFee },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};
